import React from 'react';

const GameSocketContext = React.createContext();
export default GameSocketContext;